import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryEventTypesWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.event-types",
  name: "Movements by type",
  description: "Movements by type using the reusable report-widget visualization.",
  apps: [
    "home",
    "inventory",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "field",
          field: "event_type",
          as: "event_type",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "event_id",
          as: "events",
        },
      ],
      group_by: [
        {
          field: "event_type",
        },
      ],
      order_by: [
        {
          ref: "events",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Movements by type",
    subtitle: "Live RQL report",
    output: "pie",
    visualization: "donut",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "107 movements",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
